import { Navigate } from '@tanstack/react-router'

import { resolvePortalEntryPath } from '@/lib/auth/portal-routes'
import type { PortalKind } from '@/lib/auth/token-storage'

export function PortalEntryRedirect({ portal }: { portal: PortalKind }) {
  return <Navigate replace to={resolvePortalEntryPath(portal)} />
}
